import request from '@/utils/request';

export async function readAlarms(id, type) {
  return request(`/api/alarm/closeAlarm?ID=${id}&type=${type}`);
}
